module.exports = __webpack_public_path__ + "img/exchange-icon.231c5a8e.png";